import React from 'react';
import styled from 'styled-components';
import Button from '@prisjakt/ui-button';
import { layout, media } from '@prisjakt/ui-base';
import { slideHideableVariant } from '@prisjakt/customization_prisjakt/variants/hideable';
import { Hideable } from '@regular_ui/lib/components/hideable';
import { List } from '@regular_ui/lib/components/list';
import { Axis, Speed, Delay, Direction } from '@regular_ui/lib/definitions';
import { applyFilterAreaHeight } from '../../../category/components/filter/components/apply-filter-button/styles';

type AppliedFilterCountProps = {
  inverted?: boolean;
};

export const AppliedFilterCount = styled.span<AppliedFilterCountProps>`
  align-items: center;
  border-radius: 50%;
  background: ${({ inverted, theme }) =>
    inverted ? theme.pill.inverted.bg : theme.pill.primary.bg};
  color: ${({ inverted, theme }) =>
    inverted ? theme.pill.inverted.text : theme.pill.primary.text};
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  height: 20px;
  justify-content: center;
  margin: 0 ${layout.spacing.xSmall};
  width: 20px;
`;

export const Wrapper = styled.section`
  padding: 0 ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.small};
`;

export const Filter = styled.div``;

export const FilterTitle = styled.h2.attrs({ className: 'show-for-sr' })``;

export const Group = styled.li`
  list-style: none;
`;

export const GroupTitle = styled.h3`
  font-size: ${layout.fontSizes.base.desktop.rem};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const NoContent = styled.div`
  border-radius: ${layout.borderRadius};
  background: ${p => p.theme.bg.secondary};
  padding: ${layout.spacing.small} ${layout.spacing.xSmall};
  margin: ${layout.spacing.xxSmall} 0;
  text-align: center;
`;

export const SectionSeparator = styled.li.attrs({ role: 'presentation' })`
  border-bottom: 1px solid ${({ theme }) => theme.lines.primary};
`;

export const SectionList = styled(List).attrs({
  direction: Axis.Y,
  styledComponentProps: { as: 'ul' },
  separator: <SectionSeparator />,
})`
  list-style: none;
`;

export const SectionListItem = styled.li`
  padding-bottom: ${layout.spacing.small};
  /* @TODO: No padding on SidebarContent? */
`;

export const MobileFilterDialog = styled.div`
  min-width: 0;
  flex: 1 1 0;
  background: ${p => p.theme.bg.primary};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 102;
  overflow-x: hidden;
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch;
  /* Makes sure no content is hidden behind the "apply filter" area */
  ::after {
    content: '';
    display: block;
    height: ${applyFilterAreaHeight}px;
  }
`;

export const MobileFilterToggle = styled(Button)`
  display: none;
  width: 100%;
  ${media.mediumDown`
    display: block;
  `}
`;

export const MobileFilterHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const MobileFilterView = styled(Hideable).attrs({
  // NOTE: Casting as `any` to suppress the TS error. Should be fixed when we have time
  variant: slideHideableVariant as any,
  speed: Speed.Fast,
  delayIn: Delay.Short,
})`
  > * {
    flex: 1 0 auto;
  }
`;

export const MobileFilterLeftView = styled(MobileFilterView).attrs({
  styledComponentProps: {
    slideDirection: Direction.Left,
  },
})``;

export const MobileFilterRightView = styled(MobileFilterView).attrs({
  styledComponentProps: {
    slideDirection: Direction.Right,
  },
})``;

export const FilterSectionButtonList = styled.div`
  padding: 0 ${layout.spacing.xSmall};
  width: 100%;
`;

export const MobileSectionSeparator = styled(SectionSeparator).attrs({
  as: 'div',
})``;

export const MobileSectionList = styled(SectionList).attrs({
  styledComponentProps: { as: 'div' },
  separator: <MobileSectionSeparator />,
})`
  width: 100%;
`;
